module.exports = __webpack_public_path__ + "img/ResidentOffice3.7a91d71b.png";